import { render, staticRenderFns } from "./CardNav.vue?vue&type=template&id=17a4b837&scoped=true&"
import script from "./CardNav.vue?vue&type=script&lang=js&"
export * from "./CardNav.vue?vue&type=script&lang=js&"
import style0 from "./CardNav.vue?vue&type=style&index=0&id=17a4b837&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a4b837",
  null
  
)

export default component.exports